import styled from '@xstyled/styled-components'
import type { AvatarSize, Pixels } from './Common.styles'
import {
  StyledCommonAvatar,
  numericAvatarSizeToCircleSize
} from './Common.styles'

export const StyledAnonymousAvatar = styled(StyledCommonAvatar)({
  backgroundColor: 'grey.l4',
  color: 'grey.l1'
})

export function getAnonymousAvatarIconsSize(size: AvatarSize = 'md'): Pixels {
  return `${numericAvatarSizeToCircleSize(size) / 2}px`
}
